import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';
const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getPillProgress = async (nftId) => {
    try {
        const url = `${BASE_URL}/event/nftHolding/${nftId}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
